import type { Result } from 'neverthrow';

import { apiRequest, type ApiError } from './client';

/**
 * Mirror of `@mailchute/db`'s User schema fields the SPA cares about.
 * Kept as a structural copy here so the SPA doesn't transitively
 * depend on the backend DB layer.
 */
export interface MyProfile {
  readonly user_id: string;
  readonly tenant_id: string;
  readonly email: string;
  readonly created_at: string;
  readonly name?: string;
  readonly country?: string;
  readonly marketing_opt_in?: boolean;
}

export interface ProfileUpdate {
  readonly name?: string;
  readonly country?: string;
  readonly marketing_opt_in?: boolean;
}

/**
 * `PATCH /api/me` — partial-update the calling user's profile fields.
 * Called by the SPA from `SignUpDialog` after auto-sign-in completes,
 * to persist name / country / marketing_opt_in from the sign-up form.
 */
export function updateMyProfile(profile: ProfileUpdate): Promise<Result<MyProfile, ApiError>> {
  return apiRequest<MyProfile>({
    method: 'PATCH',
    path: '/me',
    body: profile,
  });
}
